import React, { useState } from 'react';
import { numberLayout } from './data';
import { FiDelete } from 'react-icons/fi';
import cn from 'classnames';
import { KeyboardType } from './useScreenKeyboard';
import { PiArrowFatUpFill, PiArrowFatUpLight } from 'react-icons/pi';
import { AiOutlineEnter } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';
import SimpleKeyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

import { motion } from 'framer-motion';

const sizes: any = {
  Space: 120,
  Enter: 60,
  Backspace: 60,
};

type Props = {
  handleKeyPress: (key: string) => void;
  keyboardType: KeyboardType;
  canChangeKeyboardType?: boolean;
  isOpened?: boolean;
};

export const KeyBoard: React.FC<Props> = (props) => {
  const { handleKeyPress, canChangeKeyboardType = true, keyboardType } = props;

  const [isUpperCase, setIsUpperCase] = useState(false);
  const [layoutName, setLayoutName] = useState('default');

  const label: any = {
    CaseSwitch: isUpperCase ? <PiArrowFatUpFill /> : <PiArrowFatUpLight />,
    Enter: <AiOutlineEnter />,
    NumberPad: <span className={'text-gray-500 text-sm'}>123</span>,
    Space: <span className={'text-sm'}>space</span>,
    AlphabeticPad: (
      <div className={'text-gray-500 text-sm'}>
        <div>ABC</div>
        <div className={'w-[80%] bg-gray-300 h-[1px] mx-auto'}></div>
      </div>
    ),
    '{bksp}': <FiDelete />,
    Close: <IoClose />,
  };

  const onKeyDown = (key: string) => {
    switch (key) {
      case 'CaseSwitch': {
        return setIsUpperCase(!isUpperCase);
      }
      case '{shift}': {
        return handleShift();
      }
      case '{lock}': {
        return handleShift();
      }
      default: {
        handleKeyPress(key);
      }
    }
  };

  const handleShift = () => {
    const newLayoutName = layoutName === 'default' ? 'shift' : 'default';
    setLayoutName(newLayoutName);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={'relative'}
    >
      {keyboardType === 'Alphabetic' ? (
        <SimpleKeyboard
          baseClass="react-simple-keyboard"
          layoutName={layoutName}
          onKeyPress={(key) => {
            onKeyDown(key);
          }}
          preventMouseDownDefault={true}
        />
      ) : (
        <div
          className={'px-4 py-2 relative '}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {numberLayout.map((rows, index) => {
            return (
              <div>
                <div className={cn('flex gap-2 justify-center my-2 gap-5')}>
                  {rows.map((key) => {
                    if (key === 'AlphabeticPad' && !canChangeKeyboardType)
                      return (
                        <span
                          style={{
                            flex: '50px 0 1',
                          }}
                        />
                      );
                    return (
                      <button
                        type="button"
                        tabIndex={-1}
                        onMouseDown={(e) => {
                          onKeyDown(key);
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        style={{
                          flex: '50px 0 1',
                        }}
                        className={cn(
                          'border-2 flex text-md font-medium justify-center items-center rounded-full aspect-square  border-primary-default   px-1.5 py-1'
                        )}
                        key={key}
                      >
                        {label[key] ?? (isUpperCase ? key.toUpperCase() : key.toLowerCase())}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <span className={'shadow-sm mx-auto rounded-full w-8 h-8 flex justify-center items-center'}>
        <IoClose />
      </span>
    </motion.div>
  );
};
